import {useContext} from "react";
import {OperationalSearchState, SearchState} from "./SearchState";
import {LegacyCommonOrgSearchContext} from "../client-search";
import {EntitySourceType} from "../../entities";
import {
  LegacyOperationalSearchStateContext,
  OperationalSearchStateContext
} from "../operational-search";

// TODO: convert this to a Client-specific hook once real OE search is implemented.
export function useSearchState(
  entitySourceType: EntitySourceType
): SearchState {
  return useContext(
    entitySourceType === EntitySourceType.OPERATIONAL
      ? LegacyOperationalSearchStateContext
      : LegacyCommonOrgSearchContext
  );
}

export function useOperationalSearchState(): OperationalSearchState {
  return useContext(OperationalSearchStateContext);
}
